module.exports = __webpack_public_path__ + "static/media/team6.9728fe9f.jpg";